import {createSelector} from 'reselect';
import {getContactNumberRules, getSettings} from '../selectors';

export default createSelector(
  [getSettings, getContactNumberRules],
  (settings, fieldRules) => settings?.contact_number_min_length || fieldRules?.minLength,
);
